import React from 'react';
import moment from 'moment';
import { Tag } from 'antd';

const useColumns = () => {
  return [
    {
      title: 'Contrat',
      dataIndex: 'contratId',
      key: 'contratId',
      sorter: true,
      render: (contrat) => {
        return contrat?.number;
      }
    },
    {
      title: 'Objet',
      dataIndex: 'objetReclamation',
      key: 'objetReclamation',
      sorter: true
    },
    {
      title: 'Statut',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (status) => {
        if (status === 'WAITING') {
          return <Tag color="#f50">En attente</Tag>;
        }

        if (status === 'IN_PROGRESS') {
          return <Tag color="#2db7f5">En cours</Tag>;
        }

        if (status === 'VALID') {
          return <Tag color="#87d068">Validé</Tag>;
        }

        if (status === 'CLOSED') {
          return <Tag color="#108ee9">Traitée</Tag>;
        }
        return '';
      }
    },
    {
      title: 'Date de création',
      dataIndex: 'created_at',
      sorter: 'true',
      key: 'created_at',
      render: (date) => {
        return date && moment(date).format('DD-MM-YYYY');
      }
    },
    {
      title: 'Assureur Conseil',
      dataIndex: 'insurer',
      sorter: 'true',
      key: 'insurer',
      render: (insurer) => {
        return insurer?.name;
      }
    }
  ];
};

export default useColumns;
